import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    CCID: "",
    AssessmenType: "",
    Grade: "",
    SchoolId:"",
    Section:"",
    HQUserId:"",
}

const PrincipalTeacherDashboard = createSlice({
    name: "PrincipalTeacherDashboard",
    initialState,

    reducers: {
        PrincipalTeacherDashboarData(state, action) {
            return {
                // ...state,
                CCID: action.payload.CCID,
                AssessmenType: action.payload.AssessmenType,
                Grade: action.payload.Grade,
                SchoolId: action.payload.SchoolId,
                Section: action.payload.Section,
                HQUserId:action.payload.HQUserId,
            };
        }
    }
})
export const { PrincipalTeacherDashboarData } = PrincipalTeacherDashboard.actions;
export default PrincipalTeacherDashboard.reducer;